// =============================================================================
// Repository: Email Verification — edge function calls for code send/verify
// =============================================================================

import { supabase } from '@/integrations/supabase/client';

export interface SendVerificationCodeResult {
  success?: boolean;
  error?: string;
}

export interface VerifyEmailCodeResult {
  verified?: boolean;
  error?: string;
}

/**
 * Send a verification code to the user's email via edge function.
 */
export async function sendVerificationCode(
  email: string,
  resend: boolean = false
): Promise<SendVerificationCodeResult> {
  const { data, error } = await supabase.functions.invoke('send-verification-code', {
    body: { email, resend },
  });

  if (error) {
    let errorMessage = "Impossible d'envoyer le code. Veuillez réessayer.";
    try {
      const errorBody = await error.context?.json?.();
      if (errorBody?.error) {
        errorMessage = errorBody.error;
      }
    } catch {
      // Use generic message
    }
    return { error: errorMessage };
  }

  if (data?.error) {
    return { error: data.error };
  }

  return { success: true };
}

/**
 * Verify a code entered by the user via edge function.
 */
export async function verifyEmailCode(code: string): Promise<VerifyEmailCodeResult> {
  const { data, error } = await supabase.functions.invoke('verify-email-code', {
    body: { code },
  });

  if (error) {
    let errorMessage = "Une erreur est survenue. Veuillez réessayer.";
    try {
      const errorBody = await error.context?.json?.();
      if (errorBody?.error) {
        errorMessage = errorBody.error;
      }
    } catch {
      // Use generic message
    }
    return { error: errorMessage };
  }

  if (data?.error) {
    return { error: data.error };
  }

  return { verified: true };
}
